import { render } from "./HomePageCms.vue?vue&type=template&id=52ddd3fe"
import script from "./HomePageCms.vue?vue&type=script&lang=js"
export * from "./HomePageCms.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Working\\GLMA\\baik\\baicpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__